import { render } from "./AuditRiver.vue?vue&type=template&id=724622d1&scoped=true"
import script from "./AuditRiver.vue?vue&type=script&lang=js"
export * from "./AuditRiver.vue?vue&type=script&lang=js"

import "./AuditRiver.vue?vue&type=style&index=0&id=724622d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724622d1"]])

export default __exports__